export const AppRoutes = {
  /* login */
  main: '/',
  login: '/login',
  changePassword: '/change-password',
  notFound: '/not-found',
  preAlertFileShare: '/shipper/file-share/pre-alert/:encrypt',

  /* 貨物トレース情報検索 */
  cargoInformationSearch: '/cargo-trace-information',
  preAlert: '/cargo-trace-information/trace-info/pre-alert',
  preAlertSearch: '/cargo-trace-information/trace-info/pre-alert/:hblno/:cresysid',
  preAlertSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information/trace-info/pre-alert/${hblNo}/${creSysId}`,
  preAlertChatSearch: '/cargo-trace-information/trace-info/pre-alert/:chat/:hblno/:cresysid',
  preAlertChatSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information/trace-info/pre-alert/chat/${hblNo}/${creSysId}`,
  containerInfoSearch: '/cargo-trace-information/container-info/:HBL_NO/:CRE_SYS_ID',
  containerInfoSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information/container-info/${hblNo}/${creSysId}`,
  /* 貨物トレース情報検索(輸出) */
  cargoInformationExportSearch: '/cargo-trace-information-export',
  preAlertExport: '/cargo-trace-information-export/trace-info/pre-alert',
  preAlertExportSearch: '/cargo-trace-information-export/trace-info/pre-alert/:hblno/:cresysid',
  preAlertExportSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information-export/trace-info/pre-alert/${hblNo}/${creSysId}`,
  preAlertExportChatSearch: '/cargo-trace-information-export/trace-info/pre-alert/:chat/:hblno/:cresysid',
  preAlertExportChatSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information-export/trace-info/pre-alert/chat/${hblNo}/${creSysId}`,
  containerInfoExportSearch: '/cargo-trace-information-export/container-info/:HBL_NO/:CRE_SYS_ID',
  containerInfoExportSearchId: (hblNo: string, creSysId: string) =>
    `/cargo-trace-information-export/container-info/${hblNo}/${creSysId}`,
  /* hbl-status（輸出） */
  hblStatusDocExportUpload: '/cargo-trace-information-export/:HBL_NO/:CRE_SYS_ID/document-upload',
  hblStatusDocExportUploadId: (hblNo?: string, creSysId?: string) =>
    `/cargo-trace-information-export/${hblNo}/${creSysId}/document-upload`,

  /* 貨物トレース情報検索_本船動静情報検索 */
  shipMovementSearch: '/cargo-trace-information/ship-movement-search',
  reportBundleShipUpload: '/cargo-trace-information/ship-movement-search/ship-info/ship-movement-info-upload',

  /* 通関依頼 */
  customsClearance: '/customs-clearance',
  customsClearanceRequestSearch: '/customs-clearance/customs-clearance-request-search',
  customsClearanceRequestInfo: '/customs-clearance/customs-clearance-request-info',
  customsClearanceRequestInfoSearch: '/customs-clearance/customs-clearance-request-info/:CUST_CLEAR_REQ_NO/:pre_screen',
  customsClearanceRequestInfoSearchId: (custClearReqNo: string, preScreen?: string) =>
    `/customs-clearance/customs-clearance-request-info/${custClearReqNo}/${preScreen}`,
  customsClearanceRequestRegisterSearch:
    '/customs-clearance/customs-clearance-request-register/:CUST_CLEAR_REQ_NO/:action/:pre_screen/:hbl_no',
  customsClearanceRequestRegisterSearchId: (
    custClearReqNo?: string,
    action?: string,
    preScreen?: string,
    hblNo?: string
  ) => `/customs-clearance/customs-clearance-request-register/${custClearReqNo}/${action}/${preScreen}/${hblNo}`,
  deliveryDestMaster: '/customs-clearance/delivery-dest-master',
  deliveryDestMasterSearch: '/customs-clearance/delivery-dest-master/:DELIVERY_DEST_CD/:action',
  deliveryDestMasterSearchId: (deliveryDestCd?: string, action?: string) =>
    `/customs-clearance/delivery-dest-master/${deliveryDestCd}/${action}`,
  /* 通関依頼（輸出） */
  customsClearanceExport: '/customs-clearance-export',
  customsClearanceRequestExportSearch: '/customs-clearance-export/customs-clearance-request-search',
  customsClearanceRequestExportInfo: '/customs-clearance-export/customs-clearance-request-info',
  customsClearanceRequestExportInfoSearch:
    '/customs-clearance-export/customs-clearance-request-info/:CUST_CLEAR_REQ_NO/:pre_screen',
  customsClearanceRequestExportInfoSearchId: (custClearReqNo: string, preScreen?: string) =>
    `/customs-clearance-export/customs-clearance-request-info/${custClearReqNo}/${preScreen}`,
  customsClearanceRequestExportRegisterSearch:
    '/customs-clearance-export/customs-clearance-request-register/:CUST_CLEAR_REQ_NO/:action/:pre_screen/:hbl_no',
  customsClearanceRequestExportRegisterSearchId: (
    custClearReqNo?: string,
    action?: string,
    preScreen?: string,
    hblNo?: string
  ) => `/customs-clearance-export/customs-clearance-request-register/${custClearReqNo}/${action}/${preScreen}/${hblNo}`,
  deliveryDestMasterExport: '/customs-clearance-export/delivery-dest-master',
  deliveryDestMasterExportSearch: '/customs-clearance-export/delivery-dest-master/:DELIVERY_DEST_CD/:action',
  deliveryDestMasterExportSearchId: (deliveryDestCd?: string, action?: string) =>
    `/customs-clearance-export/delivery-dest-master/${deliveryDestCd}/${action}`,

  /* 通知情報 */
  notification: '/notification',
  notificationInformation: '/notification-information',
  notificationSetting: '/notification-setting',

  /* チャット */
  chatroom: '/chatroom',
  chatroomSearch: '/chatroom/:ROOM_KIND/:ROOM_KEY',
  chatroomSearchId: (roomKind?: string, roomKey?: string) => `/chatroom/${roomKind}/${roomKey}`,

  /* サブメニュー */
  submenu: '/submenu',

  /* サブメニュー_レポート出力 */
  outputReport: '/submenu/output-report',

  /* サブメニュー_社内運用業務 */
  reportBundle: '/submenu/report-bundle',
  // trace-info
  reportBundleTraceSearch: '/submenu/report-bundle/trace-info',
  reportBundleTraceActionSearch: '/submenu/report-bundle/trace-info/:action',
  reportBundleTraceActionSearchId: (action: string) => `/submenu/report-bundle/trace-info/${action}`,
  reportBundleSubMenuActionSearch: '/submenu/report-bundle/trace-info/:strHblNo/:strCreSysIdH/:action',
  reportBundleSubMenuActionSearchId: (strHblNo?: string, strCreSysIdH?: string, action?: string) =>
    `/submenu/report-bundle/trace-info/${strHblNo}/${strCreSysIdH}/${action}`,

  /* BL一覧（輸出） */
  reportBundleTraceExportSearch: '/submenu/report-bundle/trace-info-export',
  reportBundleTraceExportActionSearch: '/submenu/report-bundle/trace-info-export/:action',
  reportBundleTraceExportActionSearchId: (action: string) => `/submenu/report-bundle/trace-info-export/${action}`,
  reportBundleSubMenuExportActionSearch: '/submenu/report-bundle/trace-info-export/:strHblNo/:strCreSysIdH/:action',
  reportBundleSubMenuExportActionSearchId: (strHblNo?: string, strCreSysIdH?: string, action?: string) =>
    `/submenu/report-bundle/trace-info-export/${strHblNo}/${strCreSysIdH}/${action}`,

  // ship-status
  reportBundleShipStatus: '/submenu/report-bundle/ship-info/ship-status',
  // hbl-status
  hblStatus: '/submenu/report-bundle/hbl-status',
  hblStatusUpdate: '/submenu/report-bundle/hbl-status/:HBL_NO/:CRE_SYS_ID/update',
  hblStatusUpdateId: (hblNo?: string, creSysId?: string) =>
    `/submenu/report-bundle/hbl-status/${hblNo}/${creSysId}/update`,
  hblStatusDocUpload: '/submenu/report-bundle/hbl-status/:HBL_NO/:CRE_SYS_ID/document-upload',
  hblStatusDocUploadId: (hblNo?: string, creSysId?: string) =>
    `/submenu/report-bundle/hbl-status/${hblNo}/${creSysId}/document-upload`,
  hblStatusInfoUpload: '/submenu/report-bundle/hbl-status/portcast-mbl-upload',
  // container-status
  containerStatus: '/submenu/report-bundle/container-status',
  // document-approval
  documentApploval: '/submenu/report-bundle/document-approval',
  // edi-log-list
  ediLogList: '/submenu/report-bundle/edi-log-list',
  ediLogListSearch: '/submenu/report-bundle/edi-log-list/:id',
  ediLogListSearchId: (id: string) => `/submenu/report-bundle/edi-log-list/${id}`,

  /* サブメニュー_マスタメンテナンス */
  masterMaintance: '/submenu/master-maintance',
  // user-maintance
  userMaintance: '/submenu/master-maintance/user-maintance',
  userMaintanceAddAction: '/submenu/master-maintance/user-maintance/add',
  userMaintanceUpdateAction: '/submenu/master-maintance/user-maintance/:conv_sis_id/:user_id/update',
  userMaintanceUpdateActionId: (conv_sis_id: string, user_id: string) =>
    `/submenu/master-maintance/user-maintance/${conv_sis_id}/${user_id}/update`,
  userMaintanceDeleteAction: '/submenu/master-maintance/user-maintance/:conv_sis_id/:user_id/delete',
  userMaintanceDeleteActionId: (conv_sis_id: string, user_id: string) =>
    `/submenu/master-maintance/user-maintance/${conv_sis_id}/${user_id}/delete`,
  // account-group-master
  accountGrMaster: '/submenu/master-maintance/account-group-master',
  accountGrMasterSearch: '/submenu/master-maintance/account-group-master/:USER_GRP_CD/:action',
  accountGrMasterSearchId: (userGrpCd?: string, action?: string) =>
    `/submenu/master-maintance/account-group-master/${userGrpCd}/${action}`,
  // status-master
  statusMaster: '/submenu/master-maintance/status-master',
  statusMasterSearch: '/submenu/master-maintance/status-master/:STATUS_MODE/:STATUS_ID/:action',
  statusMasterSearchId: (statusMode?: string, statusId?: string, action?: string) =>
    `/submenu/master-maintance/status-master/${statusMode}/${statusId}/${action}`,
  // menu-authority-master
  menuAuthorityMaster: '/submenu/master-maintance/menu-authority-master',
  menuAuthorityMasterSearch: '/submenu/master-maintance/menu-authority-master/:MENU_AUTHORITY/:action',
  menuAuthorityMasterSearchId: (menuAuthority?: string, action?: string) =>
    `/submenu/master-maintance/menu-authority-master/${menuAuthority}/${action}`,
  // display-item
  displayItem: '/submenu/master-maintance/display-item',
  displayItemSearch: '/submenu/master-maintance/display-item/:USER_ID/:SCREEN_ID/:status',
  displayItemSearchId: (userId: string, screenId: string, status: string) =>
    `/submenu/master-maintance/display-item/${userId}/${screenId}/${status}`,
  // port-master
  portMaster: '/submenu/master-maintance/port-master',
  portMasterSearch: '/submenu/master-maintance/port-master/:PORT_CLS/:PORT_CD/:action',
  portMasterSearchId: (portCls?: string, portCd?: string, action?: string) =>
    `/submenu/master-maintance/port-master/${portCls}/${portCd}/${action}`,
  // account-master
  accountMaster: '/submenu/master-maintance/account-master',
  accountMasterSearch: '/submenu/master-maintance/account-master/:ACCOUNT_ID/:action',
  accountMasterSearchId: (accountId?: string, action?: string) =>
    `/submenu/master-maintance/account-master/${accountId}/${action}`,
  // general-master
  generalMaster: '/submenu/master-maintance/general-master',
  generalMasterSearch: '/submenu/master-maintance/general-master/:HANY_KBN/:HANY_CD/:action',
  generalMasterSearchId: (hanyKbn?: string, hanyCd?: string, action?: string) =>
    `/submenu/master-maintance/general-master/${hanyKbn}/${hanyCd}/${action}`,
  // search-pattern
  searchPattern: '/submenu/master-maintance/search-pattern',
  searchPatternSearch: '/submenu/master-maintance/search-pattern/:SQL_ID/:SQL_TYPE/:USER_GRP_CD/:action',
  searchPatternSearchId: (sqlId?: string, sqlType?: string, userGrpCd?: string, action?: string) =>
    `/submenu/master-maintance/search-pattern/${sqlId}/${sqlType}/${userGrpCd}/${action}`,
  // ait-group-master
  aitGrMaster: '/submenu/master-maintance/ait-group-master',
  aitGrMasterSearch: '/submenu/master-maintance/ait-group-master/:GR_CD/:action',
  aitGrMasterSearchId: (grpCd?: string, action?: string) =>
    `/submenu/master-maintance/ait-group-master/${grpCd}/${action}`,
};
